class ScrollSlideIn extends HTMLElement {
  connectedCallback() {
    if (this._init) return; 
    this._init = true;
    // Mark the host element for fallback CSS styling
    this.classList.add('scroll-slidein-host');

    // If Scroll-Timelines are supported, we do NOT need additional JS
    const hasTimeline = CSS.supports('animation-timeline: auto');
    if (hasTimeline) return;

    // Trigger exactly when the element crosses the "50vh line":
    // rootMargin top/bottom -50% => Intersection occurs when element touches the viewport center
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview'); // starts CSS animation (fallback)
        io.unobserve(entry.target);              // run only once
      });
    }, { root: null, rootMargin: '200px 0px 0px 0px', threshold: 0 });

    io.observe(this);
    this._io = io;
  }

  disconnectedCallback() {
    // Disconnect observer when element is removed from DOM
    if (this._io) this._io.disconnect();
  }
}

// Define customized built-in element (<div is="scroll-slidein">)
// Only define if it’s not already registered AND if Scroll-Timelines are NOT supported
if (!customElements.get('scroll-slidein') && !CSS.supports('animation-timeline: auto')) {
  customElements.define('scroll-slidein', ScrollSlideIn);
}